import { Exit } from '@hotpot-arcade/ui-components';
import { useNavigate } from 'react-router-dom';
import { CommunityBadge } from './community-badge';

export const FanForgeStatusBar = () => {
  const navigate = useNavigate();
  return (
    <div
      data-fanforge-status-bar
      className="w-full p-1 bg-[rgba(0,0,0,0.4)] absolute top-discord-safe-top left-0 z-10 flex justify-between items-center select-none"
    >
      <div
        onClick={() => navigate('/')}
        className="from-btn-danger rounded-lg to-btn-danger-fade bg-gradient-to-r py-1 px-2 text-white flex gap-1 items-center"
      >
        <Exit />
        Exit Game
      </div>
      <CommunityBadge inGame />
    </div>
  );
};
